import { createFileRoute, useRouteContext } from "@tanstack/react-router";

import { OrgMember } from "../-components/org-member";

export const Route = createFileRoute("/_auth/org/$orgId/members/")({
  component: RouteComponent
});

function RouteComponent() {
  const { org } = useRouteContext({ from: "/_auth/org/$orgId/members/" });

  return (
    <div className="py-4 md:py-6">
      <OrgMember org={org} />
    </div>
  );
}
